import React from 'react';
import Popover from '@mui/material/Popover';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    marginLeft: '0',
    zIndex: '1300',
    '@media (max-width: 834px)': {
      marginLeft: '-40px'
    }
  },
  popOverBody: {
    padding: '0.2rem',
    color: 'black',
    background: 'white',
    border: '2px solid rgba(0,0,0,.2)',
    borderRadius: '0.3rem'
  },
  arrow: {
    position: 'absolute',
    top: 'calc(50% - 12px)',
    width: '0.5rem',
    height: '1rem',
    margin: '0.3rem 0',
    left: 'calc(-0.5rem - 2px)',
    right: 'revert',
    '&::before': {
      position: 'absolute',
      display: 'block',
      content: '""',
      left: '22px',
      border: 'solid transparent',
      borderWidth: '0.5rem 0.5rem 0.5rem 0',
      borderRightColor: 'rgba(0,0,0,.13)'
    },
    '&::after': {
      position: 'absolute',
      display: 'block',
      content: '""',
      border: 'solid transparent',
      left: '25px',
      borderWidth: '0.5rem 0.5rem 0.5rem 0',
      borderRightColor: '#fff'
    }
  },
  right: {
    right: 'calc(2.5rem - 2px) !important',
    left: 'revert',
    '&::after': {
      left: '22px',
      borderWidth: '0.5rem 0 0.5rem 0.5rem !important',
      borderLeftColor: '#fff !important'
    },
    '&::before': {
      left: '25px',
      borderWidth: '0.5rem 0 0.5rem 0.5rem !important',
      borderLeftColor: 'rgba(0,0,0,.13) !important'
    }
  }
}));

export default function BasicPopover({
  open,
  id,
  popoverContent,
  toggle,
  className,
  anchorEl,
  anchorPosition,
  anchorOrigin,
  transformOrigin,
  isMobile
}) {
  const classes = useStyles();
  const popoverClasses = [`${classes.root}`, 'threepp-popover'];
  if (className) {
    popoverClasses.push(className);
  }
  const arrowClasses = [`${classes.arrow}`];
  if (isMobile) {
    arrowClasses.push(classes.right);
  }
  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={toggle}
        anchorPosition={anchorPosition}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        className={popoverClasses.join(' ')}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            padding: '20px',
            boxShadow: 'none',
            borderRadius: 0
          }
        }}
      >
        <div className={classes.popOverBody}>{popoverContent}</div>
        <span className={arrowClasses.join(' ')} />
      </Popover>
    </>
  );
}
